// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__OmbtD","split":"Layout_split__-Ea4i"};